import { render } from "./CargarArchivos.vue?vue&type=template&id=2871082e&scoped=true"
import script from "./CargarArchivos.vue?vue&type=script&lang=js"
export * from "./CargarArchivos.vue?vue&type=script&lang=js"

import "./CargarArchivos.vue?vue&type=style&index=0&id=2871082e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2871082e"]])

export default __exports__